<template>
  <div>
  <center>
    <img src="@/assets/illustrations/notfound.svg" />
    <h1>User or Tag Not Found!</h1>
    <p>
      <a href="/">Go home?</a>
    </p>
  </center>
  </div>
</template>

<script>

  export default {
    name: 'NotFound'
  }

</script>

<style scoped>

  center {
    max-width: 900px;
    margin: 6vw auto;
  }
  img{
    width: 40%;
    margin: 4rem;
  }
  h1 {
    color: var(--border);
    font-size: 2em;
  }
</style>
